<template>
  <!-- 导航部分 -->
  <div class="nav" :class="$store.state.cultureHead ? '' : 'nav_top'">

    <div class="nav_content">
      <div class="nav_item" @click="tabName" :class="0 == active ?'nav_item_title':''">
        {{ title }}
        <div class="nav_item_status" :class="0 == active ?'nav_item_active':''"></div>
      </div>
      <div class="nav_item" @click="tabScore" :class="1 == active ?'nav_item_title':''">
        综合评分{{ scoreStar }}
        <div class="nav_item_status" :class="1 == active ?'nav_item_active':''"></div>

      </div>
      <div class="nav_item" @click="tabValue" :class="2 == active ?'nav_item_title':''">
        文化价值{{investAmount}}
        <div class="nav_item_status" :class="2 == active ?'nav_item_active':''"></div>

      </div>
    </div>
    <div></div>
  </div>
  <div class="height45px"></div>
  <!-- 展示区域 -->
  <div class="swipe relative" ref="swipeRef" style="position:relative">
    <!-- <van-swipe ref="swipeRef" :disabled="true"> -->
    <!-- <template #indicator> -->
    <div class="swipe__preimg-box swipe-box" v-if="$route.path !== '/culture/cate5' " @click.stop="handlePre">
      <!-- <img src="@/assets/img/icon62.png" class="swipe__preimg pointer" /> -->
    </div>
    <div class="swipe__nextimg-box swipe-box" v-if="$route.path !== '/culture/cate5' " @click.stop="handleNext">
      <!-- <img src="@/assets/img/icon61.png" class="swipe__nextimg pointer" /> -->
    </div>
    <!-- </template> -->
    <!-- <van-swipe-item style="height:200px;width:100%;"> -->
    <div class="scroll width100 content" id="scrollContent">

      <div class="img_box">
        <!-- <img src="../../../assets/img/bg3.gif" alt=""> -->

        <img :src="imgList.image" class="width100 mb10 mt2" @click="openImg(imgList.image)">
      </div>
      <p class="look">
        浏览数量:{{ browse }}<span class="look-num">浏览人数:{{ browseNum }}</span><span @click="showShare = true"
          style="color:#3f7c93">分享</span>:{{shareNum}}
      </p>
    </div>
  </div>

  <!-- 第一个弹窗 -->
  <div class="fixed r t flex b BGwhite mt80 zIndex9 width150px scroll" style="max-height:calc(100% - 80px)" ref="rightUl" v-show="showRight">
    <ul class="popup-list width100">
      <template v-for="(item,index) in LiOption" :key="item.id">
        <li :class="{ active: isActive(item.id) }" @click="handleClick(item.cate_id, item.name, item.id,index)">
         {{ item.name }}
        </li> 
      </template>
      <li class="flex cen morelist" :class="{'morelistfixed':LiOption.length > 8}">
        <img src="@/assets/img/more.png" class="width20px pointer" @click="handleTtcDialog" :onerror="imgError" />
      </li>
    </ul>
  </div>
  <!-- 第二个弹窗 -->
  <div class="fixed r t flex b BGwhite mt50 zIndex9 width150px scroll" style="max-height:calc(100% - 50px)" v-if="rateShowRight">

    <ul class="popup-list width100">
      <li class="active" @click="$router.push({path:'/culture/list',query:{id:currentLi,title:'评分记录'}})">评分人数:{{ scoreNum }}</li>
      <li @click="$router.push({path:'/culture/list',query:{id:currentLi,title:'评分记录'}})">平均分值:{{ scoreStar }}</li>
      <li @click="handleRate" id="rightDialog">我要评分</li>
      <li>
        <router-link :to="{
              path: '/culture/investment',
              query: { id: currentLi, cateId: cateId, type: 'pf',title: '评分总览' },
            }">评分总览</router-link>
      </li>
      <li @click="handleSuggest">

        意见反馈
      </li>
    </ul>
  </div>
  <!-- 第三个弹窗 -->
  <div class="fixed r t b flex BGwhite mt50 zIndex9 width150px scroll" style="max-height:calc(100% - 50px)" v-if="worthShowRight">
    <!-- <van-popup
      v-model:show="worthShowRight"
      position="right"
      :style="{ width: '181px', boxSizing: 'border-box' }"
      :overlay="false"
    > -->
    <ul class="popup-list width100">
      <li class="active" @click="$router.push({path:'/culture/list',query:{id:currentLi,title:'注资记录'}})">注资人数:{{ cultureInfo.invest_num }}</li>
      <li @click="$router.push({path:'/culture/list',query:{id:currentLi,title:'注资记录'}})">注资金额:{{ cultureInfo.invest_amount }}</li>
      <li @click="handleTz(currentLi,cateId)">
        我要注资
      </li>
      <li>
        <router-link :to="{
              path: '/culture/investment',
              query: { id: currentLi, cateId: cateId, type: 'tz' },
            }">注资一览</router-link>
      </li>
      <li>
        <router-link :to="{
              path: '/culture/investment',
              query: { id: currentLi, cateId: cateId, type: 'zt', title:'主题排名' },
            }">主题排名</router-link>
      </li>
    </ul>
    <!-- </van-popup> -->
  </div>
  <!-- 导航项的弹窗 -->
  <TtcDialog v-model:ttcdialog="ttcdialog" :ttcDialogOption="LiOption" class="zIndex9" @updatettcdialog="updatettcdialog" :currentId="currentLi">
  </TtcDialog>
  <!-- 我要评分弹窗 -->
  <RateDialog v-model:rateDialog="rateDialog" :rateid="rateid" :rateCateId="rateCateId"></RateDialog>
  <van-toast v-model:show="toastShow" style="padding: 20px 10px">
    <template #message>{{toastTitle}}
    </template>
  </van-toast>

  <!-- 分享页面 -->
  <van-share-sheet v-model:show="showShare" title="立即分享给好友" :options="options" @select="onSelect" />
</template>

<script>
import useClipboard from 'vue-clipboard3'
import { getCultureList, getInfo, addShare } from "@/api/culture.js";
import TtcDialog from "./ttcDialog.vue";
import RateDialog from "./RateDialog.vue";
import { showConfirmDialog, showFailToast, showToast } from 'vant'
export default {
  data () {
    return {
      showShare: false,// 分享弹窗显示状态
      options: [
        [
          { name: "微博", icon: "weibo" },
          { name: "QQ", icon: "qq" },
          { name: "复制链接", icon: "link" },
        ],
      ],// 方向图标
      toastShow: false,//toast提示框显示状态
      toastTitle: '已经到首页了！',//toast内容
      active: 0,
      currentId: 0,
      LiOption: [],//列表
      title: '',//当前项名称
      currentLi: 0,//当前项id
      scoreStar: 0,// 平均分
      scoreNum: 0,//评分人数
      investAmount: 0,// 注资金额
      cultureInfo: {},// 详细信息
      browse: 0,// 浏览数量
      browseNum: 0,// 浏览人数
      shareNum: 0,//分享人数
      imgList: '',// 展示图片
      showRight: false,// 第一个弹窗显示
      rateShowRight: false,//第二个弹窗显示状态(评分)
      worthShowRight: false,//第三个弹窗显示状态(投资)
      rightScrollIndex: 0,//右侧弹窗滚动的个数
      ttcdialog: false,// 列表弹窗按钮
      rateDialog: false,//进行评分显示状态
      rateid: 0,//评分id
      rateCateId: 0,//评分类型id

    }
  },
  components: {
    TtcDialog, RateDialog
  },
  props: {
    cateId: {
      type: Number,
      default: 1
    }
  },
  created () {
    this.init()
  },
  methods: {
    // 点击分享图标
    onSelect (option) {
      if (option.icon === "link") {
        const { toClipboard } = useClipboard()
        try {
          addShare({ id: this.currentLi }).then(res => {
            if (!res.errcode) {
              return
            }
          })
          toClipboard(window.location.href)
          this.showToast("复制链接成功")
        } catch (e) {
          this.showToast("当前浏览器版本不支持复制，请长按复制")
        }
        // navigator.clipboard.writeText(window.location.href);
        // this.showToast("复制成功")
      }
      if (option.icon === "qq") {
        addShare({ id: this.currentLi }).then(res => {
          if (!res.errcode) {
            return
          }
        })
        if (navigator.share) {
          navigator.share({
            title: document.title,
            text: '分享',
            url: window.location.href
          })
        } else {
          window.location.href = "https://connect.qq.com/widget/shareqq/index.html?url=" + window.location.href
        }

      }
      if (option.icon === "weibo") {
        addShare({ id: this.currentLi }).then(res => {
          if (!res.errcode) {
            return
          }
        })
        if (navigator.share) {
          navigator.share({
            title: document.title,
            text: '分享',
            url: window.location.href
          })
        } else {
          window.location.href = "http://service.weibo.com/share/share.php?url=" + window.location.href
        }
      }
    },
    //点击我要注资
    handleTz (id, cateid) {
      if (!JSON.parse(localStorage.getItem('loginInfo'))) {
        showConfirmDialog({
          title: '是否登录'
        })
          .then(() => {
            // on confirm
            this.$router.push({ path: "/login", query: { column_type: 1 } })
          })
          .catch(() => {
            // on cancel
            return
          });
        return
      }
      const data = {
        id: id,
        cate_id: cateid
      }
      this.ajax.post("civilizations/getinfo", data).then(res => {
        if (res.data.is_invest === 0) {
          showFailToast({
            className: this.$route.meta.fixed ? 'portraitRotate90' : '',
            message: '未开启注资'
          })
        } else {
          this.$router.push({ path: '/culture/myinvestment', query: { id: this.currentLi, cateId: this.cateId }, })
        }
      })
    },
    //意见反馈
    handleSuggest () {
      if (!JSON.parse(localStorage.getItem('loginInfo'))) {
        showConfirmDialog({
          title: '是否登录'
        })
          .then(() => {
            // on confirm
            this.$router.push({ path: "/login", query: { column_type: 1 } })
          })
          .catch(() => {
            // on cancel
            return
          });
        return
      } else {
        this.$router.push({ path: '/culture/feedback', query: { column_type: 1, cate_id: this.cateId, title: this.title } })
      }
    },
    // 点击我要评分
    handleRate () {
      if (!JSON.parse(localStorage.getItem('loginInfo'))) {
        showConfirmDialog({
          title: '是否登录'
        })
          .then(() => {
            // on confirm
            this.$router.push({ path: "/login", query: { column_type: 1 } })
          })
          .catch(() => {
            // on cancel
            return
          });
        return
      }
      this.ttcdialog = false;
      this.rateShowRight = false;
      const obj = this.LiOption.find((item) => {
        return (item.id = this.currentLi);
      });
      this.rateDialog = true;
      this.rateid = obj.id;
      this.rateCateId = obj.cate_id;
    },
    // 第一个弹窗 选中样式
    async handleClick (cateId, item, id, index) {
      this.currentLi = id;//选中项
      this.title = item;//选中名称
      this.rightScrollIndex = index//导航项索引位置
      this.$refs.rightUl.scrollTop = index * 37//距离底部位置
      this.showRight = false;
      await this.getCultureInfo(id, cateId);//右侧弹窗未展开 切换项
    },
    // 第一个弹窗 选中样式
    isActive (num) {
      return num === this.currentLi;
    },
    // 第一个弹窗 点击更多
    // 点击更多  
    handleTtcDialog () {
      this.ttcdialog = !this.ttcdialog;
      this.showRight = false;
      // emits('tcstatus', true)
    },
    //ttc弹窗组件 点击导航项  右侧弹窗展开 
    updatettcdialog (obj) {
      this.rightScrollIndex = obj.clickIndex
      this.ttcdialog = obj.show;
      //obj.val 为ttc弹窗点击的值，对外部进行更新
      // currentLi.value = obj.val.value;
      this.title = obj.val.name;
      // emits('tcstatus', false)
      const num = this.LiOption.findIndex((item) => {
        return item.id === obj.val.id;
      });
      this.getCultureInfo(this.LiOption[num].id, this.LiOption[num].cate_id); //右侧弹窗展开 切换项
    },
    // 切换图片 名称
    tabName () {
      this.active = 0
      this.showRight = !this.showRight
      this.rateShowRight = false
      this.ttcdialog = false
      this.$nextTick(() => {
        this.$refs.rightUl.scrollTop = this.rightScrollIndex * 37
      })
    },
    // 跳转评分
    tabScore () {
      this.active = 1
      this.ttcdialog = false
      this.showRight = false
      this.rateShowRight = !this.rateShowRight

    },
    // 跳转文化价值
    tabValue () {
      this.active = 2
      this.ttcdialog = false
      this.showRight = false
      this.rateShowRight = false
      this.worthShowRight = !this.worthShowRight


    },
    // 获取列表
    async getList (val) {
      const data = {
        cate_id: val
      }
      const backData = await getCultureList(data);
      // console.log(backData);
      this.LiOption = backData.data
      this.title = backData.data[0].name
      this.currentLi = backData.data[0].id
    },
    // 获取详情
    async getCultureInfo (id, cateId) {
      const data = {
        id: id,
        cate_id: cateId
      }
      const backData = await getInfo(data)
      this.scoreStar = backData.data.score_star//平均分
      this.scoreNum = backData.data.score_num//评分人数
      this.investAmount = backData.data.invest_amount//注资金额
      this.title = backData.data.name;//标题
      this.currentLi = backData.data.id;//当前id
      this.cultureInfo = backData.data;//详细信息
      this.browse = backData.data.browse;//浏览数量
      this.browseNum = backData.data.browse_num;//浏览人数
      this.shareNum = backData.data.share_num
      this.imgList = {//当前图片
        image: backData.data.image
      };
      this.$store.commit('tabCultureActive', backData.data.cate_id)
      this.$router.push({
        path: `/culture/cate${backData.data.cate_id}`,
        query: {
          id: backData.data.id
        }
      })
    },
    // 展示图片
    // 跳转图片显示详情页
    openImg (src) {
      // if (showRight.value == false && rateShowRight.value == false && worthShowRight.value == false) {
      this.$router.push({ path: '/images', query: { src, fixed: true } })
      // } else {
      //   showRight.value = false; rateShowRight.value = false; worthShowRight.value = false;
      // }
    },
    // 初始化
    async init () {
      await this.getList(this.cateId)
      if (this.$route.query.id) {
        this.getCultureInfo(this.$route.query.id, this.cateId)
        return
      }
      this.getCultureInfo(this.currentLi, this.cateId)

    },
    // 防止showtoast报错
    toast () { showToast('已经到首页了') },
    // 页面跳转上一步
    handlePre () {
      //获取当前选项在Lioption的位置
      const num = this.LiOption.findIndex((item) => {
        return item.id === this.currentLi;
      });
      if (num == 0) {
        if (this.cateId == 1) {
          this.toastTitle = '已经到首页了！'
          this.toastShow = true

        } else {
          this.$store.commit('tabCultureActive', this.cateId - 1)
          this.$router.push({ path: `/culture/cate${this.cateId - 1}` })
        }
      } else {
        this.getCultureInfo(this.LiOption[num - 1].id, this.cateId)

      }
      document.getElementById('scroll').scrollTop = 0

    },
    // 页面跳转下一步
    handleNext () {
      const num = this.LiOption.findIndex((item) => {
        return item.id === this.currentLi;
      });
      // 最后一页
      if (num === this.LiOption.length - 1) {
        if (this.cateId == 4) {
          this.toastTitle = '已经到尾页了！'
          this.toastShow = true
        } else {
          this.$store.commit('tabCultureActive', this.cateId + 1)
          this.$router.push({ path: `/culture/cate${this.cateId + 1}` })
        }
      } else {
        this.getCultureInfo(this.LiOption[num + 1].id, this.cateId)
      }
      document.getElementById('scroll').scrollTop = 0

    }
  },
  mounted () {
    //页面点击缩右侧弹窗
    document.addEventListener("click", (e) => {
      if (
        Array.from(e.target.classList).includes("swipe__img") ||
        Array.from(e.target.classList).includes("head") ||
        Array.from(e.target.classList).includes("container") ||
        Array.from(e.target.classList).includes("van-swipe-item") ||
        Array.from(e.target.classList).includes("van-tabs__nav") ||
        Array.from(e.target.classList).includes("look") ||
        Array.from(e.target.classList).includes("look-num") ||
        Array.from(e.target.classList).includes("van-badge__wrapper")
      ) {
        this.rateShowRight = false;
        this.worthShowRight = false;
        this.showRight = false;
      }
    });
  }
}
</script>

<style lang="scss"  scoped>
.nav{
  position: fixed;
  top: 44px;
  left: 0;
  right: 0;
  width: 100%;
  height: 45px;
  background-color: #fff;
  z-index: 10;
}
.nav_top{
    top: 0;
  }
.nav_content{
  display: flex;
  justify-content: space-around;
  width: 50%;
  margin: 0 auto;
  padding: 10px 0;
  font-weight: bold;
  font-size: 13px;
  .nav_item{
  color: #646566;
    .nav_item_status{
      width: 25px;
      height: 5px;
      margin: 0 auto;
      margin-top: 5px;
      border-radius: 20%;
    }
   
    .nav_item_active{
      background-color: #3f7c93;
    }
  }
  .nav_item_title{
      color: #000;
    }
}
.content{
  padding-top: 45px;
}
.img_box{
  min-height: 220px;
}
.look {
  /* position: absolute; */
  left: 0;
  right: 0;
  bottom: 0;
  height: 57px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #fff;
  font-size: 12px;
  color: #999999;
  padding-left: 20px;
}
.look-num {
  margin-left: 20px;
  margin-right: 20px;
}

.swipe {
  margin-top: 1.6vw;
}
.swipe__preimg-box {
  position: fixed;
  top: 44px;
  bottom: 0;
  width: 50px;
  left: 0;
}
.swipe__nextimg-box {
  position: fixed;
  top: 44px;
  bottom: 0;
  right: 0;
  width: 50px;
}
.swipe-box{
  width: 20%;
  height:80%;
}
.popup-list {
  font-size: 14px;
  color: #999999;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);
  padding: 1px 1px 36px;
}
.popup-list li {
  padding: 8px 0 8px 20px;
}
.popup-list li.active {
  background-color: #3f7c93;
  position: relative;
  color: #fff;
}
.popup-list li.active::before {
  content: "";
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 8px;
  transform: translateY(-50%);
}
.popup-list .morelist {
  padding: 8px 0;
}
.morelistfixed {
  width: 148px;
  height: 35px;
  position: fixed;
  bottom: 0;
  right: 0;
  background-color: #fff;
}
</style>
